export const useIsChannelEmpty = (isLoading: boolean, channelData?: unknown[]) =>
  (!channelData || channelData.length === 0) && !isLoading;
